<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="font-family:Calisto MT; font-size:18pt; letter-spacing:1px;  padding-top:75px; padding-bottom:15px;">About the Author</h1>
<p style="text-indent:0em;">David Johnson has had three non-fiction books about the First World War published – <em>One Soldier and Hitler, 1918: The Story of Henry Tandey VC DCM MM / The Man Who Didn’t Shoot Hitler: The Story of Henry Tandey VC and Adolf Hitler, 1918</em>; <em>Executed at Dawn: British Firing Squads on the Western Front 1914-1918</em>; <em>The Last Campaign of World War One (1990 – 2006): The Fight to Win Pardons for Those Executed.</em></p><br/>
<p style="text-indent:0em;"><em>The Enemy at Home</em> is his first novel to be published and again it is set in the First World War.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5c07bb48